import React from 'react';
import theme from '@/utils/theme';

export const StarHalf = ({color = theme.yellow}) => (
    <svg
        width='15'
        height='14'
        viewBox='0 0 15 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M6.82613 1.30223C6.97979 0.990938 7.05661 0.835292 7.16091 0.785563C7.25166 0.742296 7.35709 0.742296 7.44783 0.785563C7.55213 0.835292 7.62896 0.990938 7.78262 1.30223L9.2404 4.25554C9.28577 4.34744 9.30845 4.39339 9.34159 4.42907C9.37094 4.46066 9.40614 4.48625 9.44524 4.50443C9.4894 4.52497 9.5401 4.53238 9.64151 4.5472L12.9024 5.02382C13.2457 5.07401 13.4174 5.09911 13.4969 5.18298C13.566 5.25595 13.5985 5.35622 13.5854 5.45587C13.5702 5.57041 13.4459 5.69147 13.1973 5.93361L10.8387 8.23097C10.7651 8.30258 10.7284 8.33839 10.7046 8.38099C10.6836 8.41872 10.6702 8.46016 10.665 8.50302C10.6591 8.55143 10.6678 8.60202 10.6851 8.70318L11.2417 11.9481C11.3004 12.2903 11.3297 12.4615 11.2746 12.563C11.2266 12.6514 11.1413 12.7133 11.0424 12.7317C10.9288 12.7527 10.7751 12.6719 10.4678 12.5103L7.55261 10.9772C7.46178 10.9295 7.41637 10.9056 7.36852 10.8962C7.32616 10.8879 7.28259 10.8879 7.24022 10.8962C7.19238 10.9056 7.14696 10.9295 7.05613 10.9772L4.14098 12.5103C3.83364 12.6719 3.67997 12.7527 3.56634 12.7317C3.46748 12.7133 3.38218 12.6514 3.33419 12.563C3.27903 12.4615 3.30838 12.2903 3.36708 11.9481L3.92362 8.70318C3.94097 8.60202 3.94965 8.55143 3.94378 8.50302C3.93858 8.46016 3.9251 8.41872 3.9041 8.38099C3.88038 8.33839 3.84361 8.30258 3.77009 8.23097L1.4114 5.93361C1.1628 5.69147 1.03851 5.57041 1.02338 5.45587C1.01022 5.35622 1.04273 5.25595 1.11186 5.18298C1.19132 5.09911 1.36301 5.07401 1.70639 5.02382L4.96724 4.5472C5.06864 4.53238 5.11935 4.52497 5.16351 4.50443C5.2026 4.48625 5.2378 4.46066 5.26715 4.42907C5.3003 4.39339 5.32298 4.34744 5.36834 4.25554L6.82613 1.30223Z'
            fill='url(#paint0_linear_5808_882)'
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <defs>
            <linearGradient
                id='paint0_linear_5808_882'
                x1='0.152647'
                y1='5.58323'
                x2='7.30437'
                y2='5.58323'
                gradientUnits='userSpaceOnUse'
            >
                <stop offset='0.999236' stopColor={color}/>
                <stop offset='1' stopColor={color} stopOpacity='0'/>
            </linearGradient>
        </defs>
    </svg>
);
